<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
const VERSION_KEY = 'app_version';
const AUTH_KEY = 'auth_token'; // Key where you store authentication
const APP_VERSION = process.env.VUE_APP_VERSION || "0.0.0";

export default {
  name: "App",

  async created() {
    await this.checkVersion();
  },

  methods: {
    async checkVersion() {
      const storedVersion = localStorage.getItem(VERSION_KEY);
      
      // Only clear cache if version changed (ignore first load)
      if (storedVersion && storedVersion !== APP_VERSION) {
        await this.clearCacheAndReload();
      }
      
      // Always update to current version
      localStorage.setItem(VERSION_KEY, APP_VERSION);
    },

    async clearCacheAndReload() {
      console.log(`Version change detected (${localStorage.getItem(VERSION_KEY)} → ${APP_VERSION}). Clearing cache...`);

      try {
        // Preserve authentication if exists
        const authToken = localStorage.getItem(AUTH_KEY);
        
        // Clear all storage
        localStorage.clear();
        sessionStorage.clear();
        
        // Restore auth token if it existed
        if (authToken) {
          localStorage.setItem(AUTH_KEY, authToken);
        }

        // Clear other caches (IndexedDB, Service Workers, etc.)
        await this.clearIndexedDB();
        await this.clearCaches();
        await this.unregisterServiceWorkers();

        console.log("Cache cleared successfully");
      } catch (error) {
        console.error("Error clearing cache:", error);
      } finally {
        window.location.reload(true); // Force reload
      }
    },

    async clearIndexedDB() {
      if (window.indexedDB?.databases) {
        const databases = await window.indexedDB.databases();
        await Promise.all(
          databases.map(db => {
            return new Promise((resolve) => {
              const request = window.indexedDB.deleteDatabase(db.name);
              request.onsuccess = resolve;
              request.onerror = resolve; // Continue even if fails
            });
          })
        );
      }
    },

    async clearCaches() {
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }
    },

    async unregisterServiceWorkers() {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(r => r.unregister()));
      }
    }
  }
};
</script>